export enum WardsHttpPaths {
  Wards = '/clients/{clientCode}/wards',
  WardNames = '/clients/{clientCode}/ward-names',
  WardTypes = '/options/ward-types',
  ClientWardDetails = '/clients/{clientCode}/wards/{wardCode}',
}
